import ComingSoon from './pages/ComingSoon.jsx';

export default function App() {
  return <ComingSoon />;
}
